import React from 'react';
import { ClockIcon, CreditCardIcon, XIcon, ChevronRightIcon } from 'lucide-react';
const alerts = [{
  id: 1,
  type: 'overdue',
  title: 'Overdue Booking: Home Cleaning Service',
  description: 'Booking #1234 is 2 days overdue',
  time: '2 days ago',
  icon: <ClockIcon size={18} data-id="element-23" />,
  color: 'text-yellow-500 bg-yellow-50'
}, {
  id: 3,
  type: 'payment',
  title: 'Payment Pending Approval',
  description: '$450.00 payment for job #9012 needs approval',
  time: '1 day ago',
  icon: <CreditCardIcon size={18} data-id="element-24" />,
  color: 'text-blue-500 bg-blue-50'
}, {
  id: 4,
  type: 'overdue',
  title: 'Overdue Booking: Plumbing Repair',
  description: 'Booking #2345 is 1 day overdue',
  time: '1 day ago',
  icon: <ClockIcon size={18} data-id="element-25" />,
  color: 'text-yellow-500 bg-yellow-50'
}, {
  id: 5,
  type: 'payment',
  title: 'Payment Pending Verification',
  description: '$280.00 payment for job #3456 needs verification',
  time: '12 hours ago',
  icon: <CreditCardIcon size={18} data-id="element-26" />,
  color: 'text-blue-500 bg-blue-50'
}];
export const AlertSection = ({
  onNavigate
}) => {
  return <div data-id="element-27">
      <div className="flex items-center justify-between mb-4" data-id="element-28">
        <h2 className="text-lg font-semibold text-gray-800" data-id="element-29">Alerts</h2>
        <button onClick={() => onNavigate('alerts')} className="text-sm font-medium text-blue-600 hover:text-blue-700" data-id="element-30">
          View All
        </button>
      </div>
      <div className="bg-white rounded-lg shadow border border-gray-100 overflow-hidden" data-id="element-31">
        <div className="divide-y divide-gray-200" data-id="element-32">
          {alerts.map(alert => <AlertItem key={alert.id} alert={alert} data-id="element-33" />)}
        </div>
        <div className="p-4 bg-gray-50 border-t border-gray-200" data-id="element-34">
          <button onClick={() => onNavigate('alerts')} className="w-full py-2 flex items-center justify-center text-sm font-medium text-gray-600 hover:text-gray-900" data-id="element-35">
            Load more alerts
            <ChevronRightIcon size={16} className="ml-1" data-id="element-36" />
          </button>
        </div>
      </div>
    </div>;
};
const AlertItem = ({
  alert
}) => {
  return <div className="p-4 hover:bg-gray-50 transition-colors duration-150" data-id="element-37">
      <div className="flex items-start" data-id="element-38">
        <div className={`p-2 rounded-md mr-3 ${alert.color}`} data-id="element-39">{alert.icon}</div>
        <div className="flex-1 min-w-0" data-id="element-40">
          <div className="flex justify-between items-start" data-id="element-41">
            <div data-id="element-42">
              <h4 className="text-sm font-medium text-gray-900" data-id="element-43">
                {alert.title}
              </h4>
              <p className="text-sm text-gray-500 mt-0.5" data-id="element-44">
                {alert.description}
              </p>
              <span className="text-xs text-gray-400 mt-1 block" data-id="element-45">
                {alert.time}
              </span>
            </div>
            <button className="text-gray-400 hover:text-gray-500" data-id="element-46">
              <XIcon size={16} data-id="element-47" />
            </button>
          </div>
        </div>
      </div>
      <div className="mt-3 flex space-x-2" data-id="element-48">
        {alert.type === 'payment' && <button className="px-3 py-1 text-xs font-medium rounded-md bg-blue-50 text-blue-600 hover:bg-blue-100" data-id="element-49">
            Approve
          </button>}
        <button className="px-3 py-1 text-xs font-medium rounded-md bg-gray-100 text-gray-600 hover:bg-gray-200" data-id="element-50">
          Details
        </button>
      </div>
    </div>;
};